
import React from 'react';
import { MetricCard } from '../../atoms';
import { OverviewSectionIcon } from '../../../overview/OverviewSectionIcon';
import { UserAlert } from '../../atoms/alerts';
import { Bargraph } from '../../organisms';
import { commaingNumber } from '../../../../utils';

const WalletUtilizationCommon = ({ metricObj,  loading, benefitName, walletUtilizationObj, uniqueUsers, activeCustomerCount }) => {
    const { repeat_users, bardataWallet, barLabelsWallet, barBgColorsWallet, activeEmployeeUtilizationPercentage, repeatSponsoredUserCount, unique_users,
            repeatSponsoredUserCountPercentage, monthOnMonthMaxValue, totalAmountSpent } = metricObj;

    const getStepSize = (maxValue) => {
        if (maxValue <= 0) return 10;
        else if (maxValue <= 10) return 1;
        else if (maxValue <= 100) return 10;
        else if (maxValue <= 1000) return 100;
        else if (maxValue <= 10000) return 1000;
        else if (maxValue <= 100000) return 10000;
        else if (maxValue <= 1000000) return 100000;
        else if (maxValue <= 10000000) return 1000000;
         return 10000000;
      };

    const roundUpToNearest = (num, roundTo) => {
        var res = Math.ceil(num / roundTo) * roundTo

        return res<= 0 ? 100 : res;
    };

    const step = getStepSize(monthOnMonthMaxValue);
    const roundedMax = roundUpToNearest(monthOnMonthMaxValue, step);
    const maxWithHeadroom = roundedMax + step;
    const pharmacy = benefitName?.toLowerCase()?.includes('pharmacy');

    return (
        <div>
            {/* { !loading ? (
                totalAmountSpent > 0 ? (
                    <div>
                        <p className='text-gray-600 text-base font-semibold mt-8 mb-3 leading-none'>
                            User and Amount Distribution
                        </p>
                        <UtilizationSankyChart
                            sankeyData={ChartWalletUtilizationData}
                            classes='px-8 py-20 border bg-white border-gray-200'
                            height={450}
                        />
                    </div>
                ) : null
            ) : (
                <div className='h-40 flex items-center justify-center'>
                    <SpinnerDotted />
                </div>
            )} */}
            <div>
                <div className='mt-6 text-xs font-semibold uppercase tracking-wider text-gray-500'>
                    Unique & repeat users
                </div>
                <div className='mt-4 grid grid-cols-1 gap-5 sm:grid-cols-2'>
                        <MetricCard
                            variant='ds-default'
                            icon={<OverviewSectionIcon name='metric_employees_utilized' />}
                            loading={loading}
                            loaderHeight={120}
                            title='Employees who utilized'
                            subTitle={`Employees who took at least one ${benefitName?.toLowerCase()}`}
                            metricValue={commaingNumber(unique_users)}
                            metricValueSuffix={`${activeEmployeeUtilizationPercentage > 0 ? `${Math.round(activeEmployeeUtilizationPercentage)}%` : 'less than 1%'} of active employees`}
                            classes='min-w-0 flex-1'
                        />
                        <MetricCard
                            variant='ds-default'
                            icon={<OverviewSectionIcon name='metric_repeat_users' />}
                            loading={loading}
                            loaderHeight={120}
                            title='Repeat users'
                            subTitle={`Employees who took more than one ${benefitName?.toLowerCase()}`}
                            metricValue={commaingNumber(repeatSponsoredUserCount)}
                            metricValueSuffix={`${repeatSponsoredUserCountPercentage > 0 ?  `${Math.round(repeatSponsoredUserCountPercentage)}%` : 'less than 1%'} of active employees`}
                            classes='min-w-0 flex-1'
                        />
                </div>
            </div>

            <p className='mt-3 text-sm italic leading-snug text-gray-600'>
                *Dependents are excluded
            </p>

            {(totalAmountSpent > 0) && (<div>
                {/* <div>
                    <div className='text-base font-semibold text-gray-500 mt-6 mb-3 leading-none'>
                        WALLET UTILIZATION
                    </div>
                    <div className='flex flex-row space-between'>
                        <MetricCard
                            loading={loading}
                            loaderHeight={120}
                            svgsrc={healthCheckMale}
                            titleClasses='font-semibold text-gray-800'
                            title='Amount Utilized'
                            subTitle={`Total utilized amount for ${benefitName?.toLowerCase()}`}
                            metricClasses='flex mt-0 text-gray-500'
                            metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(amountUtilizedPercentageAmount)}</span>}
                            metricValueSuffix={`${amountUtilizedPercentage}% of ₹${totalWalletAmount}`}
                            classes='w-1/2 inline-block mr-5'
                        />
                        <MetricCard
                            loading={loading}
                            loaderHeight={120}
                            svgsrc={male_circle}
                            titleClasses='font-semibold text-gray-800'
                            title='Avg. utilized per employee'
                            subTitle={`Total utilized sponsored wallet amount for the ${benefitName?.toLowerCase()}`}
                            metricClasses='flex mt-0 text-gray-500'
                            metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(averageUtilizePerEmployeegeAmount)}</span>}
                            metricValueSuffix={`${averageUtilizePerEmployeegeAmountPercentage}% of ₹${averageAmountAddedPerEmployees}`}
                            classes='w-1/2 inline-block'
                        />
                    </div>
                </div>

                <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'>
                    *dependents are not counted
                </p> */}

                <div className='mt-12 text-xs font-semibold uppercase tracking-wider text-gray-500'>
                    Monthly {pharmacy ? 'order' : 'appointment'} trend
                </div>
                <div className={'mt-4 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm ' + (bardataWallet && bardataWallet?.length === 0 ? 'pt-2 ' : '')} >
                    {bardataWallet && bardataWallet?.length === 0 && (
                        <UserAlert
                            para={`Months data is not available`}
                            paraClasses=' font-semibold text-gray-600'
                            imgClasses=' h-5 w-5'
                            classes=' rounded-lg p-4 mx-4 mb-2 mt-2'
                        />
                    )}
                    <Bargraph withDownload
                        id='walletutilizationbargraph'
                        loading={loading}
                        loaderHeight={300}
                        data={bardataWallet}
                        labels={barLabelsWallet}
                        backgroundColor={barBgColorsWallet}
                        height='300px'
                        type='bar'
                        ticks={{
                            min: 0,
                            max: maxWithHeadroom,
                            stepSize: step,
                        }}
                        dataPoints='amount'
                        barTag='amount'
                        xAxesLabel={'Months of the year'}
                        yAxesLabel={pharmacy ? 'Number of orders delivered' : 'Number of completed appointments'}
                    />
                </div>
            </div>
            )}
        </div>
    )
};

export default WalletUtilizationCommon;
